/** 끝의 슬래시 하나를 제거한다 — base URL 뒤에 경로를 이어붙일 때 `//` 중복을 막는다. */
export function normalizeBaseUrl(baseUrl: string): string {
  return baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
}
